import axios from "axios";
import { API_URL } from "../App";

export const fetchUserData = async () => {
  const config = {
    method: "post",
    url: API_URL + `/session`,
    withCredentials: true,
    headers: { "Content-Type": "application/json" },
  };

  try {
    const response = await axios(config);
    if (response.data[0].error_msg) {
      throw new Error(response.data[0].error_msg);
    }
    return {
      userId: response.data[0].userId,
      user: response.data[0].user,
      fullName: response.data[0].fullName,
      email: response.data[0].email,
    };
  } catch (error) {
    console.error("Wylogowano lub brak sesji", error);
    return null;
  }
};
